import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';

import Select from './Select';
import { initials } from '../../lib/common';
import * as styles from './styles.css';

function DropdownSelect({ options, input, compact, disabled, className }) {
  /*
  return (
    <Select
      input={input}
      disabled={disabled}
    >
      {options.map(option => (
        <option value={option.id}>{option.name}</option>
      ))}
    </Select>
  );
  */
  const selected = options.find(option => option.id === input.value);

  return (
    <div className={`btn-group ${className}`}>
      <button
        className={`btn btn-default btn-xs dropdown-toggle ${styles.dropDownSelect}`}
        disabled={disabled}
        data-toggle="dropdown"
        aria-expanded="false"
      >
        {selected && (compact ? initials(selected.name) : selected.name)}
        &nbsp;
        <span className="caret" />
      </button>

      <ul className={`dropdown-menu ${styles.dropdownMenu}`}>
        {options.map(option => (
          <li key={`${option.id}_${option.name}`}>
            <a
              onClick={() => input.onChange(option.id)}
              style={{ width: '100%', height: '100%' }}
            >
              {option.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

DropdownSelect.propTypes = {
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string.isRequired,
    })),
    PropTypes.instanceOf(List)
  ]),
  className: PropTypes.string,
  compact: PropTypes.bool,
  disabled: PropTypes.bool,
  input: PropTypes.shape({
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
  }),
};

export default DropdownSelect;
